class HttpClientClass {
  private _token: string = "";

  public set token(token: string) {
    this._token = token;
  }

  public async httpRequest<TResponse>(
    url: string,
    body?: any,
    customConfig: RequestInit = {},
    isPrivate: boolean = true,
  ): Promise<TResponse> {
    const accessToken = isPrivate ? this._token : null;

    const headers: HeadersInit = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    if (!accessToken && isPrivate) {
      return Promise.reject("No access token set.");
    }

    const config: RequestInit = {
      method: body ? "POST" : "GET",
      ...customConfig,
      headers: {
        ...headers,
        ...(customConfig.headers ?? []),
      },
    };
    if (body) {
      config.body = JSON.stringify(body);
    }

    return fetch(url, config)
      .then<TResponse>(async response => {
        let data;
        if (response.status !== 204) {
          data = await response.json();
        }

        if (response.ok) {
          return data;
        } else {
          return Promise.reject(data);
        }
      })
      .catch(err => Promise.reject(err));
  }

  public get<TResponse>(
    url: string,
    customConfig: RequestInit = {},
    isPrivate: boolean = true,
  ): Promise<TResponse> {
    return this.httpRequest<TResponse>(
      url,
      null,
      {
        ...customConfig,
        method: "GET",
      },
      isPrivate,
    );
  }

  public post<TResponse>(
    url: string,
    body: any,
    customConfig: RequestInit = {},
    isPrivate: boolean = true,
  ): Promise<TResponse> {
    return this.httpRequest<TResponse>(
      url,
      body,
      {
        ...customConfig,
        method: "POST",
      },
      isPrivate,
    );
  }

  public patch<TResponse>(
    url: string,
    body: any,
    customConfig: RequestInit = {},
    isPrivate: boolean = true,
  ): Promise<TResponse> {
    return this.httpRequest<TResponse>(
      url,
      body,
      {
        ...customConfig,
        method: "PATCH",
      },
      isPrivate,
    );
  }

  public put<TResponse>(
    url: string,
    body: any,
    customConfig: RequestInit = {},
    isPrivate: boolean = true,
  ): Promise<TResponse> {
    return HttpClient.httpRequest<TResponse>(
      url,
      body,
      {
        ...customConfig,
        method: "PUT",
      },
      isPrivate,
    );
  }

  public delete<TResponse>(
    url: string,
    body?: any,
    customConfig: RequestInit = {},
  ): Promise<TResponse> {
    return this.httpRequest<TResponse>(url, body, {
      ...customConfig,
      method: "DELETE",
    });
  }
}

const HttpClient = new HttpClientClass();

export default HttpClient;
